import api from './api';

const API_PREFIX = '/catalogInventory';

const getCatalogInventoryAll = ({ limit, page, customerEnvId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/all${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getCatalogInventoryDeviceAll = ({ limit, page, customerEnvId, query, deviceId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/device/${deviceId}/all${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getCatalogInventoryDetails = ({ customerEnvId, catalogInventoryId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${catalogInventoryId}`);

const getCatalogInventoryDevices = ({ limit, page, customerEnvId, catalogInventoryId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${catalogInventoryId}/affectedDevices${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getCatalogInventoryNotConnectedDevices = ({ limit, page, customerEnvId, catalogInventoryId, query }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${catalogInventoryId}/notConnectedDevices${query}`, {
    params: {
      ...(limit ? { Limit: limit } : {}),
      ...(page ? { Page: page } : {}),
    },
  });

const getCatalogInventoryTabCounts = ({ customerEnvId, catalogInventoryId }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${catalogInventoryId}/tabCounts`);

const getExportDevices = ({ customerEnvId, catalogInventoryId, query, exportAffected }) =>
  api.get(`${API_PREFIX}/${customerEnvId}/${catalogInventoryId}/exportDevices${query}`, {
    params: {
      ExportAffected: exportAffected,
    },
  });

const CatalogInventoryService = {
  getCatalogInventoryAll,
  getCatalogInventoryDeviceAll,
  getCatalogInventoryDetails,
  getCatalogInventoryDevices,
  getCatalogInventoryNotConnectedDevices,
  getCatalogInventoryTabCounts,
  getExportDevices,
};

export default CatalogInventoryService;
